import React from "react";
import styled from "styled-components";
import { EmailIcon, FaxIcon, InstaIcon, PhoneIcon } from "../FooterIcons";
import { Link } from "react-router-dom";

const FooterContainer = styled.div`
  background: #1d1311;
  padding: 7px 0 33px;
`;

const FooterBorder = styled.div`
  border-top: 1px solid #696969;
  border-bottom: 1px solid #696969;
  display: flex;
  justify-content: center;
`;

const FooterContent = styled.div`
  width: 309px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const FooterTitle = styled.h2`
  color: white !important;
  font-size: 26px;
  font-weight: 800;
  font-style: italic;
  margin-top: 33px 0 15px;
`;

const FooterSubtitle = styled.p`
  color: #aecdc2 !important;
  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  letter-spacing: 1.54px;
  margin: 0 0 30px;
`;

const FooterLogoContainer = styled(Link)`
  display: flex;
  justify-content: center;
  align-self: flex-end;
  align-items: center;
  background: #1d1311;
  border-radius: 50%;
  transform: scale(1.2);
  padding: 8px 0;
`;
const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: flex-start;
  gap: 25px;
  span,
  a {
    color: #e4bdff !important;
    text-decoration: none;
  }
`;

const FooterLink = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;

  a {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
  }

  &:hover {
    a,
    span {
      color: rgb(246, 243, 247) !important;
      transition: color 0.2s ease;
    }
    svg path {
      stroke: rgb(246, 243, 247) !important;
      transition: stroke 0.2s ease;
    }
  }
`;

const MobileFooterV2 = () => {
  return (
    <FooterContainer>
      <FooterBorder>
        <FooterContent>
          <FooterTitle>It’s time to be well again. Let’s talk.</FooterTitle>
          <FooterSubtitle>
            AUSTIN-AREA CONCIERGE PHYSICAL THERAPY
          </FooterSubtitle>
          <FooterLinks>
            <FooterLink>
              <a href="mailto:Jackie@BravoAustinPT.com">
                <EmailIcon />
                <span>Jackie@BravoAustinPT.com</span>
              </a>
            </FooterLink>
            <FooterLink>
              <a href="tel:512-222-7787">
                <PhoneIcon />
                <span>512-222-7787</span>
              </a>
            </FooterLink>
            <FooterLink>
              <a href="fax:512-566-3042">
                <FaxIcon />
                <span>512-566-3042</span>
              </a>
            </FooterLink>
            <FooterLink>
              <a href="https://www.instagram.com/bravoaustinpt/">
                <InstaIcon />
                <span>@BravoAustinPT</span>
              </a>
            </FooterLink>
          </FooterLinks>
          <FooterLogoContainer to="/">
            <img
              src="/bravo-circle-logo.png"
              alt="Bravo Physical Therapy logo"
              style={{ width: "131px", height: "auto" }}
            />
          </FooterLogoContainer>
        </FooterContent>
      </FooterBorder>
    </FooterContainer>
  );
};

export default MobileFooterV2;
